
import React, { useEffect, useState, forwardRef, useRef } from "react";
import ReactToPrint, { PrintContextConsumer, useReactToPrint } from "react-to-print";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import Paper from '@mui/material/Paper';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import {
    Box, Button, Grid, Dialog, DialogTitle, TextField, DialogActions, Popper,
    TablePagination, Typography, InputAdornment, DialogContent, IconButton, Tooltip, Card, CardContent, Container, Popover, Divider, Hidden, Snackbar, Autocomplete, ButtonGroup, Grow, ClickAwayListener, MenuList, MenuItem, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, ToggleButtonGroup, ToggleButton
} from '@mui/material';
import { Icon } from '@iconify/react';
import SyncAltIcon from '@mui/icons-material/SyncAlt';

import Breadcrumb from "../../reusableComponent/Breadcrumb";
import { StyledTableRow, StyledTableCell } from '../../reusableComponent/StyledTable'

import { useDispatch, useSelector } from "react-redux";
import { editDeletePurchaseInvoice, getCNSList, getOutstandingReport, getPurchaseInvoiceList, getSaleInvoiceList } from "../../../actions/actions";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { dateConversion } from "../../reusableComponent/dateConversionOnEntryPage";
import styles from '.././../../styles.module.css';
import ExcelDownload from "../../reusableComponent/ExcelDownload";
import { ERPinput } from "../../reusableComponent/ErpTextField";
import { makeStyles } from "@mui/styles";
import download_excel from '../../../images/download_excel1.png'
import { DownloadTableExcel } from 'react-export-table-to-excel';
import { getDateFormat } from "../../reusableComponent/getDateFormat";
import * as FileSaver from 'file-saver';
import XLSX from 'sheetjs-style';
import OutstandingPrint from "./OutstandingPrint";
import { BackBtn } from "../../reusableComponent/BackBtn";

const useStyles = makeStyles({
    option: {
        fontSize: 12,
    },
    noOptionsLabel: {
        fontSize: '12px',
    },

});

const ComponentToPrintRow = forwardRef((props, ref) => {
    const { value, filterOption, acStatement } = props;
    return (
        <div className="print-source" ref={ref}>
            <OutstandingPrint reportPrint={value} filterOption={filterOption} acStatement={acStatement} />
        </div>
    );
});
const ComponentToPrintOrderWrapper = ({ reportPrint, filterOption, acStatement }) => {
    
    const ref = useRef();
    return (
        <div style={{ display: "flex" }}>
            <ReactToPrint
                trigger={() => <span style={{display:'flex', justifyContent:'center'}}>  <Icon icon="flat-color-icons:print" width="20" height="20" /> </span> }
                content={() => ref.current}
            />
            <div style={{ display: 'none' }}>
                <ComponentToPrintRow ref={ref} value={reportPrint} filterOption={filterOption} acStatement={acStatement} />
            </div>
        </div>
    );
};

function Outstanding(props) {

    const classes = useStyles();
    const dispatch = useDispatch();
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo;
    let ref = useRef();
    const FilterOptions = ["Party Wise", 'All Parties Wise'];
    const [openFilter, setOpenFilter] = React.useState(false);
    const anchorRef = React.useRef(null);
    const [selectedIndex, setSelectedIndex] = React.useState(0);
    const tableRef = useRef(null);
    const [acStatement, setAcStatement] = React.useState('Customer');
    const [supplierName, setSupplierName] = useState(null);
    const [customerName, setCustomerName] = useState(null);

    const customerSupplierList = useSelector(state => state.CNS.CNS)
    const rows = useSelector(state => state.outstanding.outstanding)

    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset-UTF-8';
    const fileExtension = '.xlsx';
    const fileName = FilterOptions[selectedIndex] === 'Party Wise' ? 'PartyWiseOutstandingReport' : 'AllPartiesWiseOutstandingReport'
    const [enablePagination, setEnablePagination] = useState(false)

    const exportToExcel = () => {
        setEnablePagination(true)
        setTimeout(() => {
            const table = tableRef.current;
            const data = [];

            const headerRow = [];
            table.querySelectorAll('thead > tr > th').forEach((headerCell) => {
                const boldStyle = {
                    font: { bold: true },
                };
                const cellValue = { v: headerCell.textContent, s: boldStyle };
                headerRow.push(cellValue);
            });
            data.push(headerRow);

            table.querySelectorAll('tbody > tr').forEach((row) => {
                const rowData = [];
                row.querySelectorAll('td').forEach((cell) => {
                    rowData.push(cell.textContent);
                });
                data.push(rowData);
            });

            const ws = XLSX.utils.aoa_to_sheet(data);

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'data');

            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

            const blob = new Blob([excelBuffer], { type: fileType });

            FileSaver.saveAs(blob, fileName + fileExtension);
            setEnablePagination(false);
        }, 50);
    };


    const handleChangeCustomer = (event, newValue) => {
        setCustomerName(newValue)
        dispatch(getOutstandingReport({ filterOption: FilterOptions[selectedIndex], companyId: userInfo.companyId, CNS_Type: acStatement, CNS_id: acStatement === 'Customer' ? newValue == null ? null : newValue.CSNId : null }))
    }

    const handleChangeSupplier = (event, newValue) => {
        setSupplierName(newValue)
        dispatch(getOutstandingReport({ filterOption: FilterOptions[selectedIndex], companyId: userInfo.companyId, CNS_Type: acStatement, CNS_id: acStatement === 'Supplier' ? newValue == null ? null : newValue.CSNId : null}))
    }

    const fetchData = () => {
        dispatch(getOutstandingReport({ filterOption: FilterOptions[selectedIndex], companyId: userInfo.companyId, CNS_Type: acStatement, CNS_id: acStatement === 'Customer' ? customerName : supplierName}))
       dispatch(getCNSList({financialYear: userInfo.financialYear, companyId: userInfo.companyId, CNS_Type: acStatement }));
    };

    const handleChange = (event) => {
        setAcStatement(event.target.value);
       dispatch(getCNSList({financialYear: userInfo.financialYear, companyId: userInfo.companyId, CNS_Type: event.target.value }));
        dispatch(getOutstandingReport({ filterOption: FilterOptions[selectedIndex], companyId: userInfo.companyId, CNS_Type: event.target.value, CNS_id: event.target.value === 'Customer' ? (customerName == null ? null : customerName.CSNId) : (supplierName == null ? null : supplierName.CSNId)}))
    };

    const handleMenuItemClick = (event, index) => {
        setSelectedIndex(index);
        setOpenFilter(false);
        dispatch(getOutstandingReport({ filterOption: FilterOptions[index], companyId: userInfo.companyId, CNS_Type: acStatement, CNS_id: acStatement === 'Customer' ? (customerName == null ? null : customerName.CSNId) : (supplierName == null ? null : supplierName.CSNId)}))
    };

    const handleToggle = () => {
        setOpenFilter((prevOpen) => !prevOpen);
    };

    const handleCloseFilter = (event, reason) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpenFilter(false);
    };

    const controlProps = (item) => ({
        checked: acStatement === item,
        onChange: handleChange,
        value: item,
        name: 'color-radio-button-demo',
        inputProps: { 'aria-label': item },
    });

    const [rowsPerPage, setRowsPerPage] = React.useState(10)
    const [page, setPage] = React.useState(0)

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value)
        setPage(0)
    }

    useEffect(() => {
        fetchData()
    }, []);


    const CustomTableRow = ({ row }) => (
        <>
            <StyledTableRow
                key={row.pi_id}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
                <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.CNS_Name}</StyledTableCell>
                <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.invoiceNo}</StyledTableCell>
                <StyledTableCell align="left" className={`${styles.list_table_body}`} > {dateConversion(row.invoiceDate)} </StyledTableCell>
                <StyledTableCell align="right" className={`${styles.list_table_body}`}>{parseFloat(row.invoiceAmt).toFixed(2)}</StyledTableCell>
                <StyledTableCell align="right" className={`${styles.list_table_body}`}>{parseFloat(row.paidAmt).toFixed(2)}</StyledTableCell>
                <StyledTableCell align="right" className={`${styles.list_table_body}`}>{parseFloat(row.dueAmt).toFixed(2)}</StyledTableCell>
                <StyledTableCell align="right" className={`${styles.list_table_body}`}>{row.ageInDays}</StyledTableCell>
            </StyledTableRow>
        </>
    );

    return (
        <>
          <Breadcrumb
                        routeSegments={[
                            { name: 'Reports', path: '/reports/' },
                            { name: 'Outstanding Report' },
                        ]}
                    />
            <Paper className={`${styles.list_container}`}>
               
                <Box sx={{ display: 'flex' }}>
                    <Grid container spacing={0.2} sx={{ pt: 0.5, pb: 0.5 }}>
                        <Grid md={12} xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <RadioGroup sx={{ backgroundColor: '#0c5b80', marginBottom: '4px', padding: '4px', borderRadius: '4px' }}
                                row
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="row-radio-buttons-group"
                            >
                                <FormControlLabel
                                    control={<Radio size="small"   {...controlProps('Customer')}
                                        sx={{
                                            padding: '0px 12px',
                                            color: '#ffffff',
                                            '&.Mui-checked': {
                                                color: '#ffffff',
                                            },
                                        }} />}
                                    name="acStatement"
                                    value="Customer"
                                    onChange={handleChange}
                                    checked={acStatement === 'Customer'}
                                    label={<span style={{ fontSize: '12px', color: '#ffffff' }}>Customer Wise</span>}
                                />
                                <FormControlLabel
                                    control={<Radio size="small" {...controlProps('Supplier')}
                                        sx={{
                                            padding: '0px 12px',
                                            color: '#ffffff',
                                            '&.Mui-checked': {
                                                color: '#ffffff',
                                            },
                                        }} />}
                                    name="acStatement"
                                    value="Supplier"
                                    onChange={handleChange}
                                    checked={acStatement === 'Supplier'}
                                    label={<span style={{ fontSize: '12px', color: '#ffffff' }}> Supplier Wise</span>}
                                />
                            </RadioGroup>
                        </Grid>
                        <Grid item md={6} xs={12}>
                            {/* <Typography className={`${styles.page_title}`}>Outstanding Report </Typography> */}
                        </Grid>
                        <Grid item md={6} xs={12} style={{ display: 'flex', }}>
                            <Grid container spacing={1} >
                                <Grid item xs={3.5}>
                                    
                                </Grid>
                              
                                <Grid item xs={6.4}>
                                    {acStatement === 'Customer' ?
                                        <Autocomplete sx={{ marginBottom: '10px' }}
                                            fullWidth
                                            classes={{
                                                option: classes.option,
                                            }}
                                            noOptionsText={
                                                <span className={classes.noOptionsLabel}>No options</span>
                                            }
                                            options={customerSupplierList}
                                            value={customerName}
                                            onChange={handleChangeCustomer}
                                            getOptionLabel={(option) => option.CNS_Name}
                                            getOptionSelected={(option, value) => option.id === value.CSNId}
                                            renderInput={(params) => <ERPinput required
                                                placeholder="Select Customer"
                                                {...params} />}
                                        />

                                        :
                                        <Autocomplete sx={{ marginBottom: '10px' }}
                                            fullWidth
                                            classes={{
                                                option: classes.option,
                                            }}
                                            noOptionsText={
                                                <span className={classes.noOptionsLabel}>No options</span>
                                            }
                                            options={customerSupplierList}
                                            value={supplierName}
                                            onChange={handleChangeSupplier}
                                            getOptionLabel={(option) => option.CNS_Name}
                                            getOptionSelected={(option, value) => option.id === value.CSNId}
                                            renderInput={(params) => <ERPinput required
                                                placeholder="Select Supplier"
                                                {...params} />}
                                        />}
                                </Grid>

                                <Grid item xs={0.9}>
                                    <Box sx={{ position: 'relative' }}>
                                        <ButtonGroup ref={anchorRef} aria-label="split button" size="large" sx={{
                                            border: 'none !important',
                                            width: '100%',
                                        }}>
                                            <Button
                                                sx={{
                                                    height: '25px',
                                                    color: 'black',
                                                    fontSize: '12px',
                                                    border: '1px solid #c0c0c0',
                                                }}
                                                variant="outlined"
                                                size="small"
                                                aria-controls={openFilter ? 'split-button-menu' : undefined}
                                                aria-expanded={openFilter ? 'true' : undefined}
                                                aria-label="select merge strategy"
                                                aria-haspopup="menu"
                                                onClick={handleToggle}
                                            >
                                                <ArrowDropDownIcon sx={{ height: '28px', }} />
                                            </Button>
                                        </ButtonGroup>
                                        <Popper
                                            sx={{
                                                zIndex: 6,
                                                // minWidth: "200px",
                                            }}
                                            open={openFilter}
                                            anchorEl={anchorRef.current}
                                            role={undefined}
                                            transition
                                            disablePortal
                                        >
                                            {({ TransitionProps, placement }) => (
                                                <Grow
                                                    {...TransitionProps}
                                                    style={{
                                                        transformOrigin:
                                                            placement === 'bottom' ? 'center top' : 'center bottom',
                                                    }}
                                                >
                                                    <Paper>
                                                        <ClickAwayListener onClickAway={handleCloseFilter}>
                                                            <MenuList id="split-button-menu" autoFocusItem>
                                                                {FilterOptions.map((option, index) => (
                                                                    <MenuItem sx={{ fontSize: '12px' }}
                                                                        key={option}
                                                                        // disabled={index === 2}
                                                                        selected={index === selectedIndex}
                                                                        onClick={(event) => handleMenuItemClick(event, index)}
                                                                    >
                                                                        {option}
                                                                    </MenuItem>
                                                                ))}
                                                            </MenuList>
                                                        </ClickAwayListener>
                                                    </Paper>
                                                </Grow>
                                            )}
                                        </Popper>
                                    </Box>
                                </Grid>
                                <Grid item xs={0.6}>
                                    <Box className={`${styles.excel_box}`}>
                                        <Tooltip title="Download Excel File" >
                                            {/* <DownloadTableExcel
                                                filename={FilterOptions[selectedIndex] === 'Party Wise' ? 'PartyWiseOutstandingReport' : 'AllPartiesWiseOutstandingReport'}
                                                sheet={FilterOptions[selectedIndex] === 'Party Wise' ? 'Party Wise Outstanding Report' : 'All Parties Wise Outstanding Report'}
                                                currentTableRef={tableRef.current}
                                            >
                                                <img src={download_excel} style={{ height: "20px", width: "20" }} />
                                            </DownloadTableExcel> */}
                                            <img src={download_excel} onClick={exportToExcel} style={{ height: "20px", width: "20" }} />

                                        </Tooltip>
                                    </Box>
                                </Grid>
                                <Grid item xs={0.6}>
                                    <Box className={`${styles.excel_box}`}>
                                        <Tooltip title="Print Report">
                                        <ComponentToPrintOrderWrapper reportPrint={rows} filterOption={FilterOptions[selectedIndex]} acStatement={acStatement} /> 
                                        </Tooltip>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
                {FilterOptions[selectedIndex] == "Party Wise" && (
                    <TableContainer component={Paper} style={{ overflowY: 'auto', maxHeight: 450 }}>
                        <Table sx={{ minWidth: 650 }} size="small" stickyHeader ref={tableRef}>
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell align="left" className={`${styles.table_head}`} >{acStatement === 'Customer' ? 'Customer Name' : 'Supplier Name'}</StyledTableCell>
                                    <StyledTableCell align="left" className={`${styles.table_head}`} >Invoice No </StyledTableCell>
                                    <StyledTableCell align="left" className={`${styles.table_head}`} >Date</StyledTableCell>
                                    <StyledTableCell align="right" className={`${styles.table_head}`} >Invoice Amount </StyledTableCell>
                                    <StyledTableCell align="right" className={`${styles.table_head}`} > Paid Amount</StyledTableCell>
                                    <StyledTableCell align="right" className={`${styles.table_head}`} >Due Amount </StyledTableCell>
                                    <StyledTableCell align="right" className={`${styles.table_head}`} >Age (days) </StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    enablePagination === false ? (
                                        rows && rows.map((row, index) => (
                                                <CustomTableRow key={row.pi_id} row={row} />
                                            ))
                                    ) : (
                                        rows.map((row, index) => (
                                            <CustomTableRow key={row.pi_id} row={row} />
                                        ))
                                    )
                                }
                                {rows && rows.length != 0 &&
                                    <StyledTableRow >
                                    <StyledTableCell align="center" className={`${styles.list_table_body}`} style={{borderTop:'2px solid #c0c0c0',fontSize: '16px'}}></StyledTableCell>
                                    <StyledTableCell align="center" className={`${styles.list_table_body}`} style={{borderTop:'2px solid #c0c0c0',fontSize: '16px'}}></StyledTableCell>
                                    <StyledTableCell align="right" style={{ fontSize: '16px', fontWeight: 'bold',borderTop:'2px solid #c0c0c0'}}>Total:</StyledTableCell>
                                    <StyledTableCell align="right" className={`${styles.list_table_body_Total}`} style={{borderTop:'2px solid #c0c0c0',fontSize: '16px'}}>
                                        {(rows.reduce((a, v) => a = a + parseFloat(v.invoiceAmt), 0)).toFixed(2)}
                                    </StyledTableCell>
                                    <StyledTableCell align="right" className={`${styles.list_table_body_Total}`} style={{borderTop:'2px solid #c0c0c0',fontSize: '16px'}}>
                                        {(rows.reduce((a, v) => a = a + parseFloat(v.paidAmt), 0)).toFixed(2)}
                                    </StyledTableCell>
                                    <StyledTableCell align="right" className={`${styles.list_table_body_Total}`} style={{borderTop:'2px solid #c0c0c0',fontSize: '16px'}}>
                                        {(rows.reduce((a, v) => a = a + parseFloat(v.dueAmt), 0)).toFixed(2)}
                                    </StyledTableCell>
                                    <StyledTableCell align="center" className={`${styles.list_table_body_Total}`} style={{borderTop:'2px solid #c0c0c0',fontSize: '16px'}}></StyledTableCell>
                                    </StyledTableRow>
                                }

                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
                {FilterOptions[selectedIndex] == "All Parties Wise" && (
                    <TableContainer component={Paper} style={{ overflowY: 'auto', maxHeight: 450 }}>
                        <Table sx={{ minWidth: 650 }} size="small" stickyHeader ref={tableRef}>
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell align="left" className={`${styles.table_head}`} >{acStatement === 'Customer' ? 'Customer Name' : 'Supplier Name'}</StyledTableCell>
                                    <StyledTableCell align="left" className={`${styles.table_head}`} >Contact Person </StyledTableCell>
                                    <StyledTableCell align="left" className={`${styles.table_head}`} >Contact No</StyledTableCell>
                                    <StyledTableCell align="right" className={`${styles.table_head}`} > Total Due Amount</StyledTableCell>
                                    <StyledTableCell align="right" className={`${styles.table_head}`} > Age (days)</StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                {rows && rows.map((row, index) => (
                                    <>
                                        <StyledTableRow
                                            key={row.pi_id}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                                            <StyledTableCell align="left" className={`${styles.list_table_body}`}>{row.CNS_Name}</StyledTableCell>
                                            <StyledTableCell align="left" className={`${styles.list_table_body}`} > {row.contactPerson} </StyledTableCell>
                                            <StyledTableCell align="left" className={`${styles.list_table_body}`}>{(row.mobileNo)}</StyledTableCell>
                                            <StyledTableCell align="right" className={`${styles.list_table_body}`}>{parseFloat(row.totalDueAmt).toFixed(2)}</StyledTableCell>
                                            <StyledTableCell align="right" className={`${styles.list_table_body}`}>{row.ageInDays}</StyledTableCell>
                                        </StyledTableRow>
                                    </>
                                ))}
                                {rows && rows.length != 0 &&
                                    <StyledTableRow >
                                        <StyledTableCell align="center" className={`${styles.list_table_body}`} style={{borderTop:'2px solid #c0c0c0',fontSize: '16px'}}></StyledTableCell>
                                        <StyledTableCell align="center" className={`${styles.list_table_body}`} style={{borderTop:'2px solid #c0c0c0', fontSize: '16px'}}></StyledTableCell>
                                        <StyledTableCell align="right" style={{ fontSize: '16px', fontWeight: 'bold',borderTop:'2px solid #c0c0c0'}}>Total: </StyledTableCell>
                                        <StyledTableCell align="right" className={`${styles.list_table_body_Total}`} style={{borderTop:'2px solid #c0c0c0', fontSize: '16px'}}>
                                            {(rows.reduce((a, v) => a = a + parseFloat(v.totalDueAmt), 0)).toFixed(2)}
                                        </StyledTableCell>
                                        <StyledTableCell align="center" className={`${styles.list_table_body}`} style={{borderTop:'2px solid #c0c0c0', fontSize: '16px'}}></StyledTableCell>
                                    </StyledTableRow>
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Paper>
        </>
    )
}



export default Outstanding